// extracted by css-extract-rspack-plugin
export default {"brand":"gfhC9"};